<fgb-mobile-page-header [pageTitle]="'terms.page.title'" backButtonLink="/" [showBalance]="false" [showQr]="false" />
<fgb-banner class="d-lg-block d-none" [title]="'terms.page.title' | translate" />

<div class="container mobile-container pb-5">
  <div class="row">
    <div class="col-12">
      <div class="pt-4">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3"></p>
</ng-template>
